module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/251.709c6dab.png";